@let bannerTitle = getBannerTitle(); @if (!isInCarousel) { @if (bannerTitle) {

<dot-cms-animation [animation]="getFieldAnimation(contentlet().animations, 'bannerTitle')">
  <h1 class="mb-2 text-6xl font-bold text-shadow">
    @if(!isSSR){
    <dotcms-editable-text
      [ngStyle]="{ color: contentlet()?.textColor }"
      [fieldName]="bannerTitlekey"
      mode="minimal"
      format="html"
      [contentlet]="contentlet()"
    />
    }
  </h1>
</dot-cms-animation>
} @if (contentlet().caption) {

<dot-cms-animation [animation]="getFieldAnimation(contentlet().animations, 'caption')">
  <p>
    @if(!isSSR){
    <dotcms-editable-text
      [ngStyle]="{ color: contentlet()?.textColor }"
      fieldName="caption"
      [mode]="'minimal'"
      [format]="'html'"
      [contentlet]="contentlet()"
    />
    }
  </p>
</dot-cms-animation>
} @if (contentlet()?.buttonText && contentlet()?.link) {
<!--  (click)="selectPromotionGTMEvent()"-->
<a
  class="btn btn-primary button-leaf"
  [style.backgroundColor]="contentlet()?.buttonColor"
  [ngStyle]="{ color: contentlet()?.textColor }"
  (click)="selectPromotionGTMEvent()"
>
  <div class="hover-border-top" [style.backgroundColor]="contentlet()?.buttonColor"></div>
  <div class="link-text">{{ this.contentlet().buttonText }}</div>
  <div class="hover-border-bottom" [style.backgroundColor]="contentlet()?.buttonColor"></div>
</a>
} }@else { @if (bannerTitle) {

<dot-cms-animation [animation]="getFieldAnimation(contentlet().animations, 'bannerTitle')">
  <h1>
    <span [ngStyle]="{ color: contentlet()?.textColor }" [ishServerHtml]="bannerTitle"></span>
  </h1>
</dot-cms-animation>

} @if (contentlet().caption) {
<dot-cms-animation [animation]="getFieldAnimation(contentlet().animations, 'caption')">
  <p>
    <span [ngStyle]="{ color: contentlet()?.textColor }" [ishServerHtml]="contentlet().caption"></span>
  </p>
</dot-cms-animation>
} @if (contentlet()?.buttonText && contentlet()?.link) {
<a
  class="btn btn-primary button-leaf"
  [style.backgroundColor]="contentlet()?.buttonColor"
  [ngStyle]="{ color: contentlet()?.textColor }"
>
  <div class="hover-border-top" [style.backgroundColor]="contentlet()?.buttonColor"></div>
  <div class="link-text">{{ this.contentlet().buttonText }}</div>
  <div class="hover-border-bottom" [style.backgroundColor]="contentlet()?.buttonColor"></div>
</a>
} }
